import { render, staticRenderFns } from "./FundingStatusBadge.vue?vue&type=template&id=136a8537&scoped=true"
import script from "./FundingStatusBadge.vue?vue&type=script&lang=js"
export * from "./FundingStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a8537",
  null
  
)

export default component.exports